import React, { Component } from 'react'

import PropTypes from 'prop-types'
import TextInput from 'components/UI/TextInput'
import { connect } from 'react-redux'
import { isValidCardExpiration } from 'utilities/validators'
import { setCardExpiration } from 'actions/NewPaymentMethod'
import { withTranslation } from 'react-i18next'

class ExpirationDateInput extends Component {
    render() {
        const { expiry, dispatch, t } = this.props
        return (
            <TextInput
                className="new-payment-method-form__expiry"
                label={t('paymentExpirationDateInputLabel')}
                requiredHelp={t('paymentExpirationDateInputRequired')}
                invalidHelp={t('paymentExpirationDateInputInvalid')}
                validator={isValidCardExpiration}
                maxLength={5}
                type="tel"
                value={expiry}
                placeholder="MM/ÅÅ"
                onChange={(val) => dispatch(setCardExpiration(val))}
                required
            />
        )
    }
}

ExpirationDateInput.propTypes = {
    expiry: PropTypes.string,
    dispatch: PropTypes.func,
    t: PropTypes.func,
}

function mapStateToProps({ newPaymentMethod }) {
    return {
        expiry: newPaymentMethod.expiry,
    }
}

export default connect(mapStateToProps)(withTranslation()(ExpirationDateInput))
